import { render, staticRenderFns } from "./icon-price-tag.vue?vue&type=template&id=4752041c"
import script from "./icon-price-tag.vue?vue&type=script&lang=ts"
export * from "./icon-price-tag.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports